const entryFormBlock = document.querySelector('.entry-form-block-form');

if (entryFormBlock) {
  const slides = entryFormBlock.querySelectorAll('.slide');
  const slideController = entryFormBlock.querySelector('.slide-controller');
  const buttonPrevious = slideController.querySelector('.button-previous');
  const buttonNext = slideController.querySelector('.button-next');
  const buttonSubmit = slideController.querySelector('.button-submit');
  let currentSlide = 1;
  let totalSlides = slides.length;
  const announcement = entryFormBlock.querySelector('.announcement');
  const progressBar = entryFormBlock.querySelector('.progress-bar');
  const currentSlideProgress = progressBar.querySelector('.currentSlide');
  const totalSlidesProgress = progressBar.querySelector('.totalSlides');

  // Function to update progress bar
  function updateProgressBar() {
    currentSlideProgress.textContent = currentSlide;
    totalSlidesProgress.textContent = totalSlides - 1;
  }

  // Function to update slide display
  function updateSlideDisplay() {
    slides.forEach((slide, index) => {
      slide.style.display = 'none';
      if (index === currentSlide - 1) {
        slide.style.display = 'block';
      }
    });
  }

  // Function to update button visibility
  function updateButtonVisibility() {
    if (currentSlide === 1) {
      buttonPrevious.style.display = 'none';
      buttonNext.style.display = 'block';
      buttonSubmit.style.display = 'none';
      announcement.style.display = 'none';
      progressBar.style.display = 'block';
    } else if (currentSlide === totalSlides) {
      buttonPrevious.style.display = 'block';
      buttonNext.style.display = 'none';
      buttonSubmit.style.display = 'contents';
      announcement.style.display = 'block';
      progressBar.style.display = 'none';
    } else {
      buttonPrevious.style.display = 'block';
      buttonNext.style.display = 'block';
      buttonSubmit.style.display = 'none';
      announcement.style.display = 'none';
      progressBar.style.display = 'block';
    }
  }

  // Function to update everything when slide changes
  function updateSlide() {
    updateSlideDisplay();
    updateButtonVisibility();
    updateProgressBar();
  }

  // Event listeners
  buttonPrevious.addEventListener('click', (e) => { 
    e.preventDefault();
    if (currentSlide > 1) {
      currentSlide--;
      updateSlide();
    }
  });

  buttonNext.addEventListener('click', (e) => {
    e.preventDefault();
    if (currentSlide < totalSlides) {
      currentSlide++;
      updateSlide();
    }
  });

  // Initialize the display
  updateSlide();
}